import { render, staticRenderFns } from "./MigratedData.vue?vue&type=template&id=6d9510ea"
import script from "./MigratedData.vue?vue&type=script&lang=js"
export * from "./MigratedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports